import SearchDeatails from './search-details';

export default SearchDeatails;
